<script>
import MenuItemExternal from './MenuItemExternal.vue';

export default {
  name: 'MenuItemSecondary',

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  components: {
    MenuItemExternal,
  },

  computed: {
    pageLink() {
      return this.item.fields.link.fields && this.item.fields.link.fields.slug
        ? this.item.fields.link
        : undefined;
    },

    link() {
      return this.item.fields.link.fields && this.item.fields.link.fields.url;
    },

    isRelativeLink() {
      return this.link.startsWith('/');
    },
  },
};
</script>

<template>
  <div>
    <MenuItemExternal v-if="link && !isRelativeLink" :item="item" :level="2" />

    <router-link v-else-if="link && isRelativeLink" :to="link" class="menu-item-secondary">
      {{ item.fields.heading }}
    </router-link>

    <router-link v-else-if="pageLink" :to="`/${pageLink.fields.slug}`" class="menu-item-secondary">
      {{ item.fields.heading }}
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
.menu-item-secondary {
  @include menu-item-level-2;

  &.router-link-active {
    font-weight: $font-weight-bold;
    color: $interaction-color-primary;
  }
}
</style>
